@if (pwaInstaller | async; as installer) {
  @if (installer.canInstall()) {
    <button
      type="button"
      appButton
      (click)="installer.install()"
      >
      Add to Home Screen
    </button>
  }
}
